$(document).ready(function () {
    $(document).on("submit", "form.RetMemberlessOrderForm", function () {
        $form = $(this);

        $.ajax({
            type: "POST",
            url: $form.attr("action"),
            data: $form.serialize(),
            dataType: "json",
            beforeSend: function () {
                GenerateLocalLoading($form, "show");
            },
            success: function (dt) {
                if (dt.Sonuc === true) {
                    $("#AlertResult").removeClass("alert-danger");
                    $("#AlertResult").removeClass("alert-error");

                    $form.hide();

                    $("#AlertResult").addClass("alert-success").show().find("span").html(dt.IslemSonucAciklama);
                    $(".RetTypeHome").css("display", "inline-block");
                }
                else {
                    SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                }

                $('html, body').animate({
                    scrollTop: 0
                }, 500);

            },
            error: function () {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
            },
            complete: function () {
                GenerateLocalLoading($form, "hide");
            }
        });

        return false;
    });

    /// Üyeliksiz Sipariş İade
    $(document).on("click", ".ReturnOrderMemberless", function () {

        var confirmBox = confirm('Siparişinizi iade etmek istediğinizden emin misiniz?');
        if (confirmBox == false) {
            return false;
        } else {
            var ID = $(this).attr("data-id");
            var url = getRequestRoute() + "/p/MemberlessOrders/RetMemberlessOrder";
            var form = $(".OrderForm");
            $.ajax({
                type: "POST",
                url: url,
                data: "OrderID=" + ID,
                dataType: "json",
                beforeSend: function () {
                    GenerateLocalLoading(form, "show");
                },
                success: function (dt) {
                    if (dt.Sonuc === true) {
                        SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
                        $(".Iade").html("<span>" + dt.Deger5 + "</span>");
                    }
                    else {
                        SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                    }

                    $('html, body').animate({
                        scrollTop: 0
                    }, 500);

                },
                error: function () {
                    SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
                },
                complete: function () {
                    GenerateLocalLoading(form, "hide");
                }
            });
        }
    });

    /// Üyeliksiz Sipariş İptal
    $(document).on("click", ".CancelOrderMemberless", function () {

        var confirmBox = confirm('Siparişinizi iptal etmek istediğinizden emin misiniz?');
        if (confirmBox == false) {
            return false;
        } else {
            var ID = $(this).attr("data-id");

            var url = getRequestRoute() + "/p/MemberlessOrders/CancelMemberlessOrder";

            var form = $(".OrderForm");

            $.ajax({
                type: "POST",
                url: url,
                data: "OrderID=" + ID,
                dataType: "json",
                beforeSend: function () {
                    GenerateLocalLoading(form, "show");
                },
                success: function (dt) {
                    if (dt.Sonuc === true) {
                        SwalGenerate("success", dt.IslemSonucAciklama, getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
                        $(".Iptal").html("<span>" + dt.Deger5 + "</span>");
                    }
                    else {
                        SwalGenerate("error", dt.IslemSonucAciklama, getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
                    }

                    $('html, body').animate({
                        scrollTop: 0
                    }, 500);

                },
                error: function () {
                    SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("Kapat"));
                },
                complete: function () {
                    GenerateLocalLoading(form, "hide");
                }
            });
        }
    });
});